var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMarkerBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M12 3C8.69 3 6 5.69 6 9C6 12.54 9.82 17.86 12 20.47C13.75 18.36 18 12.84 18 9C18 5.69 15.31 3 12 3ZM10.47 14L7.29 10.82L8.71 9.4L10.48 11.17L15.08 6.57L16.49 7.98L10.47 14Z",
    fill: "#1CD4FD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 1C7.59 1 4 4.59 4 9C4 14.57 10.96 22.34 11.26 22.67L12 23.49L12.74 22.67C13.04 22.34 20 14.57 20 9C20 4.59 16.41 1 12 1ZM12 20.47C9.82 17.86 6 12.54 6 9C6 5.69 8.69 3 12 3C15.31 3 18 5.69 18 9C18 12.83 13.75 18.36 12 20.47ZM15.07 6.57L10.47 11.17L8.71 9.4L7.29 10.82L10.47 14L16.48 7.99L15.07 6.57Z",
    fill: "#1CD4FD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarkerBlue);
export default __webpack_public_path__ + "static/media/marker-blue.cb0fff69afa8a16466dff07e93e995e0.svg";
export { ForwardRef as ReactComponent };